import { Navigate, Route, Routes } from 'react-router';
import { AcademicHub } from '@/packages/academic-hub';
import { AcademicSituationDetails } from '@/packages/academic-hub/pages/academic-situation-details';

export const AcademicHubRoutes = () => (
  <Routes>
    <Route index element={<AcademicHub />} />
    <Route path=":id" element={<AcademicSituationDetails />} />
    <Route path="*" element={<Navigate to="/hub-academico" replace />} />
  </Routes>
);
